import { Injectable } from '@angular/core';
import * as wjcGrid from '@grapecity/wijmo.grid';
import * as wjcCore from '@grapecity/wijmo';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import * as _ from 'lodash';
import { Observable, of, BehaviorSubject, throwError } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';

@Injectable()
export class UtilService {

   
    //Local
    //hostUrl =  'https://localhost:44314/';
    //hostUrl =  'http://uatblacklight.s3partners.net/S3.Core.Services/'; 
    // hostUrl= 'http://uatblacklight.s3partners.net/S3CoreAPI/';
    //PROD /UAT
    hostUrl =  'https://login.s3partners.net/S3.Core.Services/'; 
    loginId: string;
    clientID: string;
    addTickerInHome: string = '';
    userType: string;
    alertNotificationTitle: string; 
    innerWidth = 1068;

    constructor(private httpClient:HttpClient){
       
    }

    
    
    private handleError(error: Response) 
    {
        console.log(error);
        return Observable.throw('Error accessing tableau config details');
    }
}

